/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Status_Order_Stock_OutInputs */

const vi_status_order_stock_out = /** @type {(inputs: Status_Order_Stock_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã xuất kho`)
};

/**

* @param {Status_Order_Stock_OutInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const status_order_stock_out = /** @type {((inputs?: Status_Order_Stock_OutInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Status_Order_Stock_OutInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_status_order_stock_out(inputs)
});